import { z } from 'zod';

export const wilayaSchema = z.object({
  code: z.string(),
  nameAr: z.string(),
  nameEn: z.string(),
  communes: z.array(z.string()).optional(),
});
export type Wilaya = z.infer<typeof wilayaSchema>;
